module.exports = __webpack_public_path__ + "img/menu3.311dea9d.png";